import Box from "@mui/material/Box";
import { DashboardLayout } from "layout";

const NotFoundScreen = () => {
    return (
        <DashboardLayout isPermission title={""} route={[]}>
            <Box display="flex" justifyContent="center" alignItems="center" py={20}>
                <h2>404 | Page Not Found</h2>
            </Box>
        </DashboardLayout>
    );
};

export default NotFoundScreen;
